import { NumberValidation, StringValidation } from '../../../utils/component-validations';
import { reads } from 'macro-decorators';
import Container from './container.gjs';
import Super from './base.gjs';
import styles from './character-counter.module.scss';

export default class SpdsCoreCharacterCounter extends Super {
  arguments = [
    new NumberValidation({ required: ['limit'] }),
    new StringValidation({ optional: ['value'] }),
  ];
  baseClass = 'spds-text-input-character-counter';
  classesToMapToAttrs = ['over'];
  componentName = 'Spds::Core::CharacterCounter';
  styles = styles;

  @reads('value.length', 0) charCount;
  @reads('args.value', '') value;

  get over() {
    return this.charCount > this.args.limit;
  }

  <template>
    <Container
      @fitContent={{true}}
      class={{this.classes}}
      data-test-spds-character-counter
      {{this.validateArguments}}
      ...attributes
    >
      {{this.charCount}}/{{@limit}}
    </Container>
  </template>
}
